import { render, staticRenderFns } from "./ChannelAdamInfoModal.vue?vue&type=template&id=fa557038&scoped=true&"
import script from "./ChannelAdamInfoModal.vue?vue&type=script&lang=js&"
export * from "./ChannelAdamInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAdamInfoModal.vue?vue&type=style&index=0&id=fa557038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa557038",
  null
  
)

export default component.exports